import React from 'react';
import BreakdownRingChart from '../../../../../../../shared/designSystem/components/BreakdownRingChart';

// Thin adapter for the shared BreakdownRingChart. Migrated from the local
// BizCharts + @antv/data-set implementation. Dimension key pass-through
// preserves V1's `selectedCreativeDimension` — BreakdownRingChart reads
// `item[dimension]` directly for 'impressions' / 'totalTransactions' and
// special-cases 'CTR'. Totals map to 'Transactions' via dimensionLabels.
const TransactionCreativeRingChart = ({ data, height, selectedCreativeDimension }) => (
  <BreakdownRingChart
    data={data}
    dimension={selectedCreativeDimension}
    height={height}
    dimensionLabels={{
      impressions: 'Impressions',
      totalTransactions: 'Transactions',
      CTR: 'CTR',
    }}
  />
);

export default TransactionCreativeRingChart;
